import api from './axios';

export const fetchDiscoverSalons = (params) =>
  api.get('/discover/salons', { params }).then((r) => r.data);

export const fetchNearbySalons = (params) =>
  api.get('/discover/salons/nearby', { params }).then((r) => r.data);

export const fetchDiscoverSalonSuggestions = (params) =>
  api.get('/discover/salons/suggestions', { params }).then((r) => r.data);

export const fetchDiscoverSalon = (tenantId) =>
  api.get(`/discover/salons/${tenantId}`).then((r) => r.data);

export const fetchSalonReviews = (tenantId, params) =>
  api.get(`/discover/salons/${tenantId}/reviews`, { params }).then((r) => r.data);

export const fetchMarketplaceServices = (params) =>
  api.get('/discover/services/marketplace', { params }).then((r) => r.data);

export const fetchDiscoverCampaigns = (params) =>
  api.get('/discover/campaigns', { params }).then((r) => r.data);

export const fetchDiscoverCampaign = (campaignId) =>
  api.get(`/discover/campaigns/${campaignId}`).then((r) => r.data);

export const fetchDiscoverBranches = (tenantId) =>
  api.get(`/discover/salons/${tenantId}/branches`).then((r) => r.data);

export const fetchDiscoverServices = (tenantId, branchId) =>
  api
    .get(`/discover/salons/${tenantId}/services`, { params: branchId ? { branchId } : {} })
    .then((r) => r.data);

export const fetchBookingStaff = (tenantId, serviceId, params = {}) =>
  api
    .get(`/discover/salons/${tenantId}/booking-staff`, { params: { serviceId, ...params } })
    .then((r) => r.data);
